<template>
  <div v-loading="loading" :key="componentKey">
    <div v-if="loadingTemplate" class="well well-small">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
          <StockSection
            :snapshot="stockSnapshot"
            :stockPieChart="stockPieChart"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
          <EstimationSection :estimationRankBar="estimationRankBar"/>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
          <DispatchSection :dispatchPieChart="dispatchPieChart" />
        </el-col>
      </el-row>
      <el-row :gutter="20" type="flex" justify="center">
        <MapDashboard v-if="renderMap" :fields="fields" :key="mapKey" style="width: 98%" />
      </el-row>
      <el-row :gutter="20" type="flex" justify="end">
        <div style="padding-right: 10px;">
          <span>{{ i18nValues["lastUpdate"] }} </span>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import moment from "moment";
import StockSection from "@/components/dashboard/sections/StockSection.vue";
import DispatchSection from "@/components/dashboard/sections/DispatchSection.vue";
import EstimationSection from "@/components/dashboard/sections/EstimationSection.vue";
import MapDashboard from "@/components/dashboard/sections/MapDashboard.vue";

export default {
  name: "Dashboard",
  created: function() {
    this.buildDash();
  },
  watch: {
    $route: function() {
      this.buildDash();
    },
    globalFieldSite: {
    handler() {
      this.buildDash();
    },
    deep: true,
  },
  globalCampaign: {
    handler() {
      this.buildDash();
    },
    deep: true,
  },
  },
  components: {
    StockSection,
    MapDashboard,
    DispatchSection,
    EstimationSection,
  },
  props: {},
  computed: {
    globalFieldSite: get("globalFieldSite"),
    globalCampaign: get("globalCampaign"),
    loadingDash: get("dashboard/loadingSnapshot"),
  },
  data() {
    return {
      componentKey: null,
      renderMap: false,
      mapKey: 0,
      fullscreenLoading: null,
      loading: true,
      loadingTemplate: false,
      stockSnapshot: {},
      stockPieChart: {},
      dispatchSnapshot: [],
      dispatchPieChart: {},
      estimationRankBar: {},
      fields: [],
      fieldsEstimate: [],
      filter: {},
      labelEstimation: [],
      dataInitialEstimation: [],
      dataFinalEstimation: [],
    };
  },
  methods: {
    resetChartData() {
      this.stockSnapshot = {};
      this.stockPieChart = {};
      this.dispatchSnapshot = [];
      this.dispatchPieChart = {};
      this.estimationRankBar = {};
      this.fields = [];
      this.fieldsEstimate = [];
      this.filter = {};
      this.labelEstimation = [];
      this.dataInitialEstimation = [];
      this.dataFinalEstimation = [];
    },

    buildDash() {
      if (this.globalFieldSite && this.globalFieldSite.id != null) {
        this.loading = true;
        this.resetChartData();

        this.$store
          .dispatch("dashboard/retrieveStockSnapshot", this.globalFieldSite.id)
          .then((response) => {
            this.stockSnapshot = response;
          })
          .catch(() => {
            this.$notify.error({
              title: this.i18nValues["error"],
              message: this.i18nValues["errorSnapshot"],
              position: "bottom-right",
              duration: 7000,
            });
          });

        this.$store
          .dispatch("order/retrieveOrdersBySearch", {
            fieldSiteId: 1,
            status: "forDispatch",
          })
          .then((res) => {
            this.dispatchSnapshot = res;
            if (this.stockSnapshot && this.dispatchSnapshot) {
              this.buildCharts();
            }
            this.loading = this.loadingThreshold;
          });

        this.$store.dispatch("field/retrieveFields").then((res) => {
          this.fields = res;
          this.renderMap = true;
          this.mapKey += 1;
        });

        this.$store
          .dispatch("campaign/retrieveEstimateProduction")
          .then((response) => {
            this.fieldsEstimate = response;
            for (var i = 0; i < this.fieldsEstimate.length; i++) {
              this.labelEstimation.push(this.fieldsEstimate[i].field.name);
              this.dataInitialEstimation.push(
                this.fieldsEstimate[i].qtyEstimateHarvest
              );
              this.dataFinalEstimation.push(
                this.fieldsEstimate[i].qtyRealHarvest
              );
            }
          })
          .catch(() => {
            this.$notify.error({
              title: this.i18nValues["error"],
              message: this.i18nValues["errorSnapshot"],
              position: "bottom-right",
              duration: 7000,
            });
          });
      }
    },
    buildCharts() {
      // StockPieChart
      let series = [];
      series.push(this.stockSnapshot.amountByPlane);
      series.push(this.stockSnapshot.amountByShip);
      let labels = [];
      labels.push(this.i18nValues["plane"]);
      labels.push(this.i18nValues["ship"]);
      this.stockPieChart = {
        series,
        labels,
      };

      // DispatchPieChart
      series = [];
      series.push(this.amountBy("plane", this.dispatchSnapshot));
      series.push(this.amountBy("ship", this.dispatchSnapshot));
      labels = [this.i18nValues["plane"], this.i18nValues["ship"]];
      this.dispatchPieChart = {
        series,
        labels,
      };

      // rankingPromo bar
      // let labelEstimation = ["campo1", "campo2", "campo3"];
      // let dataInitialEstimation = [30, 60, 70];
      // let dataFinalEstimation = [20, 40, 65];

      /*for (let i = 0; i < this.snapshot.promoRanking.length; i++) {    
          labelPromoToday = labelPromoToday.concat(
            this.snapshot.promoRanking[i].promotionCode
          );
          dataPromoTrxToday = dataPromoTrxToday.concat(
            this.snapshot.promoRanking[i].trxQuantity
          );
          dataPromoDiscountToday = dataPromoDiscountToday.concat(
            this.snapshot.promoRanking[i].promotionDiscount
          );
      }*/
      this.estimationRankBar = {
        labels: this.labelEstimation,
        datasets: [
          {
            label: this.i18nValues["quantity"],
            borderColor: "#fcc468",
            fill: true,
            backgroundColor: "#fcc468",
            hoverBorderColor: "#fcc468",
            borderWidth: 8,
            data: this.dataInitialEstimation,
          },
          {
            label: this.i18nValues["quantity"],
            borderColor: "#4cbdd7",
            fill: true,
            backgroundColor: "#4cbdd7",
            hoverBorderColor: "#4cbdd7",
            borderWidth: 8,
            data: this.dataFinalEstimation,
          },
        ],
      };

      this.componentKey++
      this.loadingTemplate = true;
      this.loading = false
    },

    formatTableDate(row) {
      return this.formatDate(row.lastDelivery);
    },

    amountBy(transport, snapshot) {
      let amount = 0;
      for (let i = 0; i < snapshot.length; i++) {
        if (snapshot[i].dispatchType == transport) {
          amount++;
        }
      }
      return amount;
    },
  },
  filters: {
    format(val) {
      let auxDate = moment(val, "YYYY-MM-DDTHH:mm:ss.SSSZ");
      if (auxDate.isValid()) return auxDate.format("DD/MM/YYYY HH:mm");
      else return undefined;
    },
  },
};
</script>
